import {i18n2} from 'features/i18n/i18n';
import authFetch from './requests';
import DataSource from 'devextreme/data/data_source';

let controller;

export const downloadReportPDF = (token, filter, reportName, url, userData) => {
  controller = new AbortController();
  const signal = controller.signal;

  let options = new URLSearchParams();
  options.append('filter', JSON.stringify(filter));
  options.append('values', JSON.stringify(userData));

  return authFetch(
    `${url}?${options}`,
    {
      method: 'GET',
      headers: {
        ContentType: 'application/json; charset=utf-8',
      },
      signal: signal,
    },
    token,
  )
    .then(async (response) => {
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const blob = await response.blob();

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const file = new Blob([blob], {type: 'application/pdf'});
        window.navigator.msSaveOrOpenBlob(
          file,
          `${reportName ?? ''}${i18n2._('_reporte.pdf')}`,
        );
      } else {
        const fileURL = URL.createObjectURL(blob);
        const winparams =
          'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
          'resizable,screenX=50,screenY=50,width=850,height=1050';
        window.open(fileURL, 'Reporte', winparams);
      }

      return true;
    })
    .catch((e) => e.message);
};

export const cancelRequest = () => {
  if (controller) {
    controller.abort();
  }
};

export const ReportTypes = {
  PDF: 1,
  Excel: 2,
};

export const downloadReportGeneric = (
  token,
  filter,
  reportName,
  url,
  signature,
  type,
  userFilter,
) => {
  const dataSource = new DataSource({
    filter,
  });

  const values = {
    loadOptions: dataSource.loadOptions(),
    userFilter: userFilter,
    signature: JSON.stringify(signature),
    type,
  };

  return authFetch(
    `${url}`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;',
      },
      body: JSON.stringify(JSON.stringify(values)),
    },
    token,
  )
    .then(async (response) => {
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const blob = await response.blob();

      if (type === ReportTypes.PDF) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          const file = new Blob([blob], {type: 'application/pdf'});
          window.navigator.msSaveOrOpenBlob(
            file,
            `${reportName ?? ''}${i18n2._('_reporte.pdf')}`,
          );
        } else {
          const fileURL = URL.createObjectURL(blob);
          const winparams =
            'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
          window.open(fileURL, 'Reporte', winparams);
        }
      } else if (type === ReportTypes.Excel) {
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = `${reportName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }

      return true;
    })
    .catch((e) => e.message);
};

export const downloadMonthlyReport = (
  token,
  reportName,
  url,
  signature,
  type,
  monthlyValues,
) => {
  const body = {
    values: monthlyValues,
    signature: JSON.stringify(signature),
    type,
  };

  return authFetch(
    url,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;',
      },
      body: JSON.stringify(JSON.stringify(body)),
    },
    token,
  )
    .then(async (response) => {
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
      }

      const blob = await response.blob();

      if (type === ReportTypes.PDF) {
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, 'Reporte');
      } else {
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = `${reportName}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }

      return true;
    })
    .catch((e) => e.message);
};
